import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Navbar.css';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
const location = useLocation();

  // Close mobile menu when route changes
  useEffect(() => {
    setIsOpen(false);
}, [location]);

  return (
    <nav className="navbar">
      <div className="navbar-brand">
        <Link to="/">
          <span className="brand-icon"><i className="fas fa-heart-pulse"></i></span>
          <div className="brand-text-container">
            <span className="brand-text">Alltagsbegleitung</span>
            <span className="brand-tagline">Mit Herz in Jena</span>
          </div>
        </Link>
      </div>
      
      <button 
        className={`hamburger ${isOpen ? 'active' : ''}`} 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Menu"
      >
        <span></span>
        <span></span>
        <span></span>
      </button>
      
      <div className={`navbar-menu ${isOpen ? 'active' : ''}`}>
        <Link 
          to="/" 
          className={location.pathname === '/' ? 'active' : ''}
        >
          Startseite
        </Link>
        <Link 
          to="/services" 
          className={location.pathname === '/services' ? 'active' : ''}
        >
          Leistungen
        </Link>
        <Link 
          to="/about" 
          className={location.pathname === '/about' ? 'active' : ''}
        >
          Über mich
        </Link>
        <Link 
          to="/contact" 
          className={location.pathname === '/contact' ? 'active' : ''}
        >
          Kontakt
        </Link>
      </div>
    </nav>
  );
};

export default Navbar;
